
<div class="row">
  <div class="col-12 mb-2">
    <h4 class=" mb-0 font-header-1">Agency</h4>
  </div>
  <div class="col-12">   
    <div class="card mt-2 pt-1">
      <div class="row">       
      </div>   
      <div class="card-body">    
      <div class="row a-body d-flex align-items-center">
        <div class="col-lg-1 col-md-4 col-sm-12 ag1 mt-3">
          <button type="button" class="btn btn-sm" (click)="AgencyCreateupdate('new')"  *ngIf="fp.agencycreate">
            Add Agency
          </button>
          <!-- <button type="button" class="btn  btn-sm ms-3"
          [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000' ||
          global.globalAgencyId == null || global.globalAgencyId == undefined " (click)="getHHAXAggregator()">
          Aggregator Credentails</button> -->
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 ag1 mt-3">
          <button type="button" class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal" data-bs-target="#SFTPModal"
              [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == ''||
              global.globalAgencyId == null || global.globalAgencyId == undefined" (click)="isViewSFTP=true" id="AgencyisViewSFTP">
              SFTP Credentials</button>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 ag2 ">
          <label>Agency Name</label>
          <div class="d-flex">
            
          <input type="text"  (keyup.enter)="filterchange()" id="inputGroupSelect02"
          class="form-control element_width1" [(ngModel)]="SearchText" />
          <i class="bi bi-search mt-1 sr-ico "  for="inputGroupSelect02" (click)="getAgencyList()"></i>
        </div>
      </div>
       <div class="col-lg-2 ag3">
        <span class="row">
         <span class="col-12"><label>Show agency&nbsp;</label></span>
         <span class="col-12"><ng-select class="w-70"  [(ngModel)]="ListSendBO.statusLid" (change)="getAgencyList()" style="color: black;width:65%"
           [clearable]="false" [searchable]="true" [items]="agencyStatusList" bindLabel="lovName" bindValue="id">
         </ng-select></span>
        </span>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 ag4 mt-3">
          <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
            <i class="fa fa-repeat"> </i>Refresh
          </button>
        </div>
      </div>

      <div class="row mt-3 pt-3">
    <div class="col mt-2">
      <ejs-grid #grid [dataSource]="data | async" [allowPaging]="true" [pageSettings]="initialPage"
      [filterSettings]="filterSettings" [allowFiltering]="true" [allowResizing]="true"
      (dataStateChange)="dataStateChange($event)" [showColumnChooser]="true"
      (actionBegin)="onActionComplete($event); actionBegin($event)" [allowSorting]="true">
      <e-columns>
        <e-column headerText="Action" uid="action" textAlign="center" minWidth="100" [showInColumnChooser]="false">
          <ng-template #template let-data>
            <button class="btn btn-edit-table text-center" data-bs-toggle="modal" data-bs-target="#agencymodal"
            *ngIf="fp.agencyupdate"    (click)="
                AgencyCreateupdate('edit'); selectAgencydetails(data)
              ">
              <i class="fa fa-edit" ></i></button>&nbsp;

              <button *ngIf="isSuperAdmin" class="btn btn-edit-table text-center" data-bs-toggle="modal" id="agencynotes"
                      (click)="opennote(data)" data-bs-target="#notesforagency">Notes</button>&nbsp;
          </ng-template>
        </e-column>
        <e-column field="agencyName" minWidth="140" headerText="Name" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="agencyCode" minWidth="100" headerText="Code" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="email" minWidth="100" headerText="Email" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="phone" minWidth="100" headerText="Phone" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="street" minWidth="100" headerText="Street" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="city" minWidth="100" headerText="City" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="state" minWidth="100" headerText="State" type="string">
          <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
          </ng-template>
        </e-column>
        <e-column field="zipCode" minWidth="100" headerText="Zip Code" type="number"></e-column>
        <e-column field="statusLidName" headerText="Status" minWidth="100" type="number">
        </e-column>

        <!--------------------------------table header icon---------------->
        <e-column width="50" [showInColumnChooser]="false">
          <ng-template #headerTemplate let-data>
            <div>
              <span id="show" (click)="show()"><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
            </div>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>

    </div>
      </div>
      </div>
      
    </div>
  </div>
</div>






<!-- /////////////////////////// Agency Create and Update //////////////////////////////////// -->
<span id="openModal" data-bs-target="#agencymodal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="agencymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span *ngIf="ModelType == 'new'"> Create Agency</span>
          <span *ngIf="ModelType == 'edit'">Update Agency</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr != ''" role="alert">
        <p>{{ saveErr }}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr = ''">
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-2 d-flex justify-content-between">
                <label class="font-header mt-1">General Info</label>

                <button class="btn btn-sm text_right" [disabled]="ModelType == 'new'" data-bs-toggle="modal"
                  data-bs-target="#CompanyModal" (click)="companyConfig(Agency)">
                  Company
                </button>
              </div>
              <hr />
              <form [formGroup]="AgencyGroup">
                <div class="row">
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input type="file" id="imageUpload" accept=".png, .jpg, .jpeg" />
                        <label for="imageUpload"></label>
                      </div>
                      <div class="avatar-preview">
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-2 col-md-2 col-xs-3">
                    <label class="label">Status&nbsp;<sup class="super-script">&nbsp;*</sup></label>
                  </div>
                  <div class="col-lg-2 col-sm-3 col-md-3 col-xs-3">
                    <select class="form-control" [(ngModel)]="Agency.statusLid" formControlName="statusLid">
                      <option *ngFor="let st of statusList" [value]="st.Key">
                        {{ st.Value }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="
                      AgencyGroup.controls.statusLid.touched &&
                      AgencyGroup.controls.statusLid.invalid
                    ">
                    <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.statusLid.errors.required">
                      Agency status is required
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12 lablestyle">
                    <label class="label">Name&nbsp;<sup class="super-script">*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyName"
                      formControlName="agencyName" />
                   
                    <div *ngIf="
                        AgencyGroup.controls.agencyName.touched &&
                        AgencyGroup.controls.agencyName.invalid
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.agencyName.errors.required">
                        Agency name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Code&nbsp;<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyCode"
                      (ngModelChange)="
                        checkpopup('Code');
                        checkfirstLetter($event, AgencyGroup.value.agencyCode)
                      " (keypress)="omit_special_char($event)" (keydown.space)="$event.preventDefault()"
                      formControlName="agencyCode" [attr.disabled]="ModelType != 'new' ? 'disabled' : null"
                      minlength="4" />
                  </div>

                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Short Name<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyShortName"
                      formControlName="agencyShortName" />
                    <div *ngIf="
                        AgencyGroup.controls.agencyShortName.touched &&
                        AgencyGroup.controls.agencyShortName.invalid
                      ">
                      <div style="color: red; text-align: left" *ngIf="
                          AgencyGroup.controls.agencyShortName.errors.required
                        ">
                        Short name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="
                    AgencyGroup.controls.agencyCode.invalid &&
                    AgencyGroup.controls.agencyCode.touched
                  ">
                  <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.agencyCode.invalid">
                    Agency code should be more than three character
                  </div>
                </div>
                <div style="color: red; text-align: left" *ngIf="alphaErr">
                  Agency code should be starts with alphabets
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Email<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.email"
                      formControlName="email" />
                    <div *ngIf="
                        AgencyGroup.controls.email.invalid &&
                        AgencyGroup.controls.email.touched
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.email.errors">
                        Enter valid email
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Phone</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.phone" minlength="14"
                      maxlength="14" formControlName="phone" [(ngModel)]="Agency.phone" (ngModelChange)="
                        DemographicPhoneFormat('phone'); checkpopup('Phone')
                      " (keypress)="keyPress($event)" />
                    <div *ngIf="
                        AgencyGroup.controls.phone.invalid &&
                        (AgencyGroup.controls.phone.dirty ||
                          AgencyGroup.controls.phone.touched)
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.phone.errors">
                        Enter valid 10 digit number
                      </div>
                    </div>                  
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Street</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.street"
                      formControlName="street" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Fax</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.fax" minlength="14"
                      [(ngModel)]="Agency.fax" maxlength="14" formControlName="fax" (ngModelChange)="
                        DemographicPhoneFormat('fax'); checkpopup('fax')
                      " (keypress)="keyPress($event)" />

                    <div *ngIf="
                        AgencyGroup.controls.fax.invalid &&
                        (AgencyGroup.controls.fax.dirty ||
                          AgencyGroup.controls.fax.touched)
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.fax.errors">
                        Enter valid 10 digit number
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">City</label>
                    <input type="text" class="form-control text_right width66 mt-1" [(ngModel)]="Agency.city"
                      formControlName="city" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">State</label>
                    <ng-select class="text_right width66 mt-1" [items]="stateList" [searchable]="true"
                      [(ngModel)]="Agency.state" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                      formControlName="state"></ng-select>
                  </div>
                </div>
                <div class="row mb-4 mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">ZipCode</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.zipCode"
                      formControlName="zipCode" minlength="5" maxlength="10" (keypress)="keyPress($event)" />
                  </div>
                </div>
                <label class="font-header fs-5 col-12 border-2">Alternate Address</label>
                <hr />
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Street</label>
                    <input type=" text" class="form-control width66 text_right" formControlName="altStreet"
                      [(ngModel)]="Agency.altStreet" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">City</label>
                    <input type="text" class="form-control text_right width66 mt-1" formControlName="altCity"
                      [(ngModel)]="Agency.altCity" />
                  </div>
                </div>

                <div class="row mb-1 mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">State</label>
                    <ng-select class="text_right width66 mt-1" [items]="stateList" [searchable]="true"
                      [(ngModel)]="Agency.altState" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                      formControlName="altState">
                    </ng-select>
                  </div>

                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">ZipCode</label>
                    <input type="text" class="form-control text_right width66" formControlName="altZipcode"
                      [(ngModel)]="Agency.altZipcode" minlength="5" maxlength="10" (keypress)="keyPress($event)" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" [disabled]="AgencyGroup.invalid || alphaErr ||isSaveorUpdateBoolean" (click)="SaveOrUpdateAgency()">
          <span *ngIf="ModelType == 'new'"> Save</span>
          <span *ngIf="ModelType == 'edit'">Update & Close</span>
        </button>
        <button type="button" class="btn btn-sm" (click)="openDialog()" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#closemodal"></span>
<div class="modal fade modalbackgrod" id="closemodal">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Close Alert</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal">
           
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>You want to close without save?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeFun()">
          Yes
        </button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------- Company modal ----------------------------------------------->
<span id="companySpan" data-bs-toggle="modal" data-bs-target="#CompanyModal">
</span>
<div class="modal fade " id="CompanyModal" tabindex="-1" data-bs-backdrop="static"
  style="background-color: rgba(0, 0, 0, 0.5)" >
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <!-- ================== Company TABLE VIEW ================ -->
        <!-- ================== Company EDIT/ADD VIEW ================ -->
        <app-company-list *ngIf="toCompanylist.isView" (listOutputEmit)="agencyToEdit($event)"
          [listInput]="toCompanylist">
        </app-company-list>
        
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<!-- Aggregator-->
<span id="openAggregator" data-bs-toggle="modal" data-bs-target="#AggregatorModal"></span>
<div class="modal hide fade modalbackgrod" id="AggregatorModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Aggregator Credentails</h5>
        <button type="button" class="btn-close"data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">
        <div class="row" >
          <div class="col-lg-12">
            <button class="btn blue-btn mt-2 " data-bs-toggle="modal" data-bs-target="#CreateorUpdateAggregatorModal" (click)="GetCompanyDropdown()">
              Add Aggregator</button>&nbsp;&nbsp;
          </div>
        </div>
        <!-- ejs-grid -->
        <div class="row"  >
          <div class="col-lg-12">
            <ejs-grid #gridHHAX  [allowResizing]='true' [allowSorting]='true'
              [allowPaging]='true' [allowFiltering]='true' 
              [pageSettings]='initialPage' [filterSettings]='filterSettings' 
             [showColumnChooser]='true'>
              <e-columns>
                <e-column headerText="Actions" uid="action" textAlign="center" [allowFiltering]="false"
                  [showInColumnChooser]='false' minWidth=100>
                  <ng-template #template let-data>
                    <button class="btn btn-edit-table" (click)="getDetails(data)" data-bs-toggle="modal" data-bs-target="#CreateorUpdateAggregatorModal"><i
                        class="fa fa-edit"></i></button>&nbsp;
                  </ng-template>
                </e-column>
                <e-column field="companyName" headerText="Company Name" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="client_id" headerText="Client" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="client_secret" headerText="Client Secret" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="providerTaxId" headerText="Provider Tax" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div>
                      <span id='show' (click)='showAggregator()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
            
          </div>
        </div>
        <!-- for Create Aggregator -->
        <span id="openCreateorUpdateAggregator" data-bs-toggle="modal" data-bs-target="#CreateorUpdateAggregatorModal"></span>
        <div class="modal hide fade modalbackgrod" id="CreateorUpdateAggregatorModal" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title font-header" *ngIf="saveHHAXInfo.id=='00000000-0000-0000-0000-000000000000'" id="exampleModalLabel">Create
                  Aggregator</h5>
                <h5 class="modal-title font-header" *ngIf="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'" id="exampleModalLabel">Update
                  Aggregator</h5>
                <button type="button" class="btn-close"(click)="clearField()"> </button>
              </div>
              <div class="modal-body">
                <!-- Client -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Client<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string" [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                      [(ngModel)]="saveHHAXInfo.client_id" />
                  </div>
                </div>
                <!-- Company -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Company<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <ng-select [clearable]="true" [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"  [items]="companyList"
                      bindLabel="Value" bindValue="Key" [(ngModel)]="saveHHAXInfo.companyId">
                    </ng-select>
                  </div>
                </div>
                <!-- ProviderTaxId -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">ProviderTax<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string" [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                      [(ngModel)]="saveHHAXInfo.providerTaxId" />
                  </div>
                </div>
                <!-- Client Secret -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Client Secret<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string" [(ngModel)]="saveHHAXInfo.client_secret" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="SaveorUpdateHHAXAggregator()" [disabled]="saveHHAXInfo.client_id=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.client_id==undefined ||
                saveHHAXInfo.client_id==''||
                saveHHAXInfo.companyId=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.companyId==undefined ||
                saveHHAXInfo.providerTaxId=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.providerTaxId==undefined ||
                saveHHAXInfo.providerTaxId=='' ||
                saveHHAXInfo.client_secret=='00000000-0000-0000-0000-000000000000' ||   saveHHAXInfo.client_secret==undefined ||
                saveHHAXInfo.client_secret=='' ">
                  <span *ngIf="saveHHAXInfo.id=='00000000-0000-0000-0000-000000000000'">Save & Close</span>
                  <span *ngIf="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="clearField()">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
          >Close</button>
      </div>
    </div>
  </div>
</div>

  
   
<!-- <ng-template #foregroundSpinner>
  <div class="sk-fading-circle">
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div class="sk-fading-circle-dot"></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-template> -->

<!------------------------------------------------Notes-------------------------------------->
<span id="notesforagencyopen" data-bs-toggle="modal" data-bs-target="#notesforagency"></span>
<div class="modal hide fade modalbackgrod" id="notesforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg">

    <div class="modal-content">
      <div class="modal-header">
        <div class="row w-100">
          <div class="col-lg-3">
            <h5 class="modal-title font-header" id="exampleModalLabel">Notes</h5>
          </div>
          <div class="col-lg-4">
            <button data-bs-target="#addnotesforagency" data-bs-toggle="modal"
            (click)="opennewnote();" class="btn blue-btn btn-sm " id="aggagencynotes">Add Notes</button>
          </div>
          <div class="col-lg-4">
            <button class="btn blue-btn btn-sm " data-bs-target="#typelstmodalforagency" (click)="getType();" id="addtypelist"
              data-bs-toggle="modal">Type List</button>
              </div>
              <div class="col-lg-1">
                <button type="button" class="btn-close mt-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>


      </div>
      <div class="modal-body ">
        <ejs-grid #gridnotesforagency [dataSource]='datanotesforagency | async'
         [allowResizing]='true'
          [allowSorting]='true' 
          [allowPaging]='true'
         [pageSettings]='initialPage1' 
         (resizeStop)="onResizeNotes($event)"
          (actionBegin)="onActionCompleteNotes($event)" 
          [allowTextWrap]='true' [textWrapSettings]='wrapSettings'
          (dataStateChange)='dataStateChangeNotes($event)' [showColumnChooser]='true'>
          <e-columns>
            <e-column minWidth=100 headerText="Actions" uid="action">
              <ng-template #template let-data>
                <button class="btn btn-edit-table mr-2" data-bs-target="#addnotesforagency" data-bs-toggle="modal"
                (click)="editNote(data);"><i class="fa fa-edit"></i></button>&nbsp;
                  <button 
  class="btn btn-delete-table" 
  (click)="deleteNoteId = data.id" 
  data-bs-toggle="modal" 
  data-bs-target="#deletenoteforagency">
  <i class="fa fa-trash"></i>
</button>
                
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="date" headerText="Date" type='date' [format]='formatOptions1'></e-column>
            <e-column minWidth=100 field="initial" headerText="Initials" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="notes" headerText="Agency Notes" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="typeListName" headerText="Type" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column width="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div class="d-none d-lg-block">
                  <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                    </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
        <div *ngIf="NotesAgencyDataList.length == 0" class="text-center" style="color:red">
          <p>No data available</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" aria-label="Close" id="Agencycloseagencyfooterbtn">Close</button>
      </div>
    </div>

  </div>
</div>
<!-----------------------------------Add and Update Notes--------------------------------------->
<span id="addnotesforagencyopen" data-bs-toggle="modal" data-bs-target="#addnotesforagency"></span>
<div class="modal hide fade modalbackgrod" id="addnotesforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog ">

    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="Notes.id=='00000000-0000-0000-0000-000000000000'">Add Notes</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="Notes.id!='00000000-0000-0000-0000-000000000000'">Update Notes</h5>
        <button type="button" class="btn-close mt-0" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body ">
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Date<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-9">
            <input type="datetime-local" class="form-control w-100" [(ngModel)]="Notes.date" id="Date" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Initials<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="Notes.initial" disabled="true" id="Initials"/>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Notes<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="Notes.notes" id="Notes"/>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold"> Type <sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-9">
            <ng-select *ngIf="Notes.id=='00000000-0000-0000-0000-000000000000'" [multiple]="true" [(ngModel)]="Notes.multipletype" [items]="typedropdown" id="typedropdown"
              bindLabel="typeName" bindValue="id" [disabled]="Notes.notes==''
              ||Notes.notes==null ">

            </ng-select>
            <ng-select *ngIf="Notes.id!='00000000-0000-0000-0000-000000000000'" [(ngModel)]="Notes.typeListId" [items]="typedropdown" bindLabel="typeName" id="typeNamedrop"
              bindValue="id">

            </ng-select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-primary" type="button" [disabled]="(Notes.multipletype.length==0)||
          (Notes.notes==''|| Notes.notes==null||Notes.notes==undefined)" (click)="saveNote(Notes)" id="saveclosenotes"
          *ngIf="Notes.id=='00000000-0000-0000-0000-000000000000'">Save &
          Close</button>
        <button class="btn btn-sm btn-primary" type="button" [disabled]="(Notes.typeListId==undefined||Notes.typeListId==null)||
            (Notes.notes==''|| Notes.notes==null||Notes.notes==undefined)" (click)="saveNote(Notes)" id="saveupdatenotes"
          *ngIf="Notes.id!='00000000-0000-0000-0000-000000000000'">Update &
          Close</button>
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="notespopclose">Close</button>
      </div>
    </div>

  </div>
</div>
<!--------------------------Type List-------------------------------------------------------->
<span id="typeforagencyopen" data-bs-toggle="modal" data-bs-target="#typelstmodalforagency"></span>
<div class="modal hide fade modalbackgrod" id="typelstmodalforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog">

    <div class="modal-content">
      <div class="modal-header">
        <div class="row w-100">
          <div class="col-lg-8">
            <h5 class="modal-title font-header" id="exampleModalLabel">Type</h5>
          </div>
        
          <div class="col-lg-3 d-flex justify-content-between align-items-center">
            <!-- Add Type Button -->
            <button 
            (click)="opennewnote(); addnewtype();" 
            id="addtype"
            class="btn blue-btn btn-sm" 
            data-bs-toggle="modal" 
            data-bs-target="#addtypeforagency">
            Add Type
        </button>
    
        <!-- Close Button with some gap on the right -->
        <button 
            type="button" 
            class="btn-close ms-3" 
            data-bs-dismiss="modal" 
            aria-label="Close">
        </button>
          </div>
        
        </div>


      </div>
      <div class="modal-body ">
        <ejs-grid #grid [dataSource]='typelst' [allowResizing]='true' [allowSorting]='true'
        [filterSettings]='filterOptions1'>
          <e-columns>
            <e-column minWidth=100 headerText="Actions">
              <ng-template #template let-data>
                <button class="btn btn-edit-table " data-bs-target="#addtypeforagency" data-bs-toggle="modal" id="edittype"
                  (click)="notetype=data"><i class="fa fa-edit"></i></button>

              </ng-template>
            </e-column>
            <e-column minWidth=100 field="typeNumber" headerText="Number" type="number"></e-column>
            <e-column minWidth=100 field="typeName" headerText="Type Name">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>


          </e-columns>
        </ejs-grid>
        <div *ngIf="TypeNotesDataList.length == 0" class="text-center" style="color:red">
          <p>No data available</p>
        </div>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="edittypeclose">Close</button>
      </div>
    </div>

  </div>
</div>
<!------------------------Add Update Type-->
<span id="addtypeforagencyopen" data-bs-toggle="modal" data-bs-target="#addtypeforagency"></span>
<div class="modal hide fade modalbackgrod" id="addtypeforagency" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog ">

    <div class="modal-content">
      <div class="modal-header">

        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="notetype.id=='00000000-0000-0000-0000-000000000000'"> Add Type</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="notetype.id!='00000000-0000-0000-0000-000000000000'">Update Type</h5>
        <button type="button" class="btn-close mt-0" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Number</label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="notetype.typeNumber" [disabled]="true" id="Number" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Type Name</label>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control w-100" [(ngModel)]="notetype.typeName" id="TypeName" />
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-primary" type="button" 
        [disabled]="!notetype.typeName || notetype.typeName.trim() === '' || notetype.typeNumber == null || notetype.typeNumber === ''" 
        (click)="savetype(notetype)" id="savetypenotes" 
        *ngIf="notetype.id == '00000000-0000-0000-0000-000000000000'">
        Save & Close
      </button>
    
      <!-- Update & Close Button -->
      <button class="btn btn-sm btn-primary" type="button" 
        [disabled]="!notetype.typeName || notetype.typeName.trim() === '' || notetype.typeNumber == null || notetype.typeNumber === ''" 
        (click)="savetype(notetype)" id="updatetypenotes" 
        *ngIf="notetype.id != '00000000-0000-0000-0000-000000000000'">
        Update & Close
      </button>
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="closetypenotes">Close</button>
      </div>
    </div>

  </div>
</div>
<!---------------------Delete Note Alert------------------------------------------------------>
<div class="modal fade modalbackgrod" id="deletenoteforagency" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Do you want to delete this record?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="deleteNote()" data-bs-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- SFTP-->
<span id="openSFTP" data-bs-toggle="modal" data-bs-target="#SFTPModal"></span>
<div class="modal hide fade modalbackgrod" id="SFTPModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">SFTP Credentials</h5>
        <button type="button" class="btn-close" (click)="isViewSFTP=false" data-bs-dismiss="modal" id="Agencysftpcredential"></button>
      </div>
      <div class="modal-body">
        <app-sftp [SFTPRelation]="SFtpEvent" *ngIf="isViewSFTP"></app-sftp>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
          (click)="isViewSFTP=false" id="Agencyclosesftpclsbtn">Close</button>
      </div>
    </div>
  </div>
</div>
